import _ from "lodash";
import moment from "moment";

const Utils = {
  apiUrl: (path) => process.env.REACT_APP_API_URL + path,

  apiHeaders: (extraparams = null) => {
    let headers = {
      headers: {
        apikey: "$2y$10$nFCFTq.c8GaIdJNzlNqYe.kbXOjRScGwcuC4OWNqpZtG5AcYq5kD6", //process.env.REACT_APP_API_KEY,
        tzoffset: moment().utcOffset(),
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "PUT,GET,POST,DELETE,OPTIONS,PATCH",
        "Access-Control-Allow-Headers":
          "Origin, Content-Type, X-Auth-Token, token, apikey, tzoffset, allow-origin, Allow-Origin",
        Accept: "application/json",
      },
    };

    const uData = Utils.getUserData();
    if (uData && _.get(uData, "token", false)) {
      headers["headers"]["token"] = uData.token;
    }

    if (extraparams) {
      headers = { ...headers, ...extraparams };
    }
    return headers;
  },

  viewerLink: (fname, path) => {
    let url = Utils.apiUrl(path);
    //if (!Utils.isImgUrl(fname)) url = `https://docs.google.com/viewer?url=${encodeURIComponent(url)}`;
    return url;
  },

  postVars: (pvals) =>
    Object.keys(pvals)
      .map(function (k) {
        return encodeURIComponent(k) + "=" + encodeURIComponent(pvals[k]);
      })
      .join("&"),

  isLoggedIn: () => {
    const dt = Utils.getUserData();
    return _.get(dt, "token", false) !== false;
  },

  removeSession: () => {
    let dt = Utils.getUserData();
    // console.log(dt, "session data")
    dt.token = false;
    // const backup = localStorage.getItem(process.env.REACT_APP_APPNAME + '-userData');
    localStorage.setItem(
      process.env.REACT_APP_APPNAME + "-userData",
      JSON.stringify(dt),
    );
  },

  getUserData: () => {
    let userData = localStorage.getItem(
      process.env.REACT_APP_APPNAME + "-userData",
    );
    if (userData) {
      return JSON.parse(userData);
    } else {
      return false;
    }
  },

  setUserData: (data) => {
    const uData = data;
    // return;
    if (uData === false) {
      //=== logout
      localStorage.removeItem(process.env.REACT_APP_APPNAME + "-userData");
    } else {
      let userData = Utils.getUserData();
      if (!userData) {
        userData = {};
      }
      userData = { ...userData, ...uData, token: _.get(data, "token", false) };
      localStorage.setItem(
        process.env.REACT_APP_APPNAME + "-userData",
        JSON.stringify(userData),
      );
    }
  },

  addToUserData: (data) => {
    let userData = Utils.getUserData();
    if (!userData) {
      userData = {};
    }
    userData = { ...userData, ...data };
    localStorage.setItem(
      process.env.REACT_APP_APPNAME + "-userData",
      JSON.stringify(userData),
    );
  },

  hasAccess: (id) => {
    let userData = Utils.getUserData();
    if (userData.plan) {
      const allowedModules = JSON.parse(_.get(userData, "plan.orgmodules", ""));
      const allowedModules1 = _.get(userData, "modules", "").split(",");
      //const modulesArray = userData.modules.split(",").map((module) => module.trim()); // Split string into array
      return (
        allowedModules.includes(id.toString()) &&
        allowedModules1.includes(id.toString())
      ); // Check if id exists in both the array then only show the module
    }
    return false;
  },

  weekdays: () => {
    return [
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
      "Sunday",
    ];
  },

  getMonthDates: (mdt) => {
    let dts = [],
      dt,
      idx = 1,
      days = moment(mdt).daysInMonth();

    do {
      dt = moment(mdt).startOf("month").day(idx++).format("YYYY-MM-DD");
      dts.push(dt);
    } while (moment(mdt).month() !== moment(dt).month());

    for (idx = 1; idx < days; idx++) {
      dt = moment(dt).add(1, "d").format("YYYY-MM-DD");
      dts.push(dt);
    }

    for (idx = moment(dt).day(); idx < 7; idx++) {
      dt = moment(dt).add(1, "d").format("YYYY-MM-DD");
      dts.push(dt);
    }
    return dts;
  },

  getAllWeekDates: (mdt, wd) => {
    //wd goes from 1=Monday to 7=Sunday
    if (wd === 7) {
      wd = 0; //== adjusting sunday to 0 - 6
    }

    let dts = [],
      dt;

    for (var idx = 0; ; idx += 7) {
      dt = moment(mdt).day(wd + idx);

      if (moment(dt).isBefore(mdt)) {
        dts.push(null);
      } else {
        if (
          parseInt(moment(dt).format("M")) !== parseInt(moment(mdt).format("M"))
        ) {
          if (
            parseInt(moment(dt).day(1).format("M")) ===
            parseInt(moment(mdt).format("M"))
          ) {
            dts.push(null);
          }
          break;
        }

        dts.push(
          moment(mdt)
            .day(wd + idx)
            .format("YYYY-MM-DD"),
        );
      }
    }

    //== handling Sundays

    if (wd === 0) {
      if (moment(mdt).endOf("month").day() !== "0") {
        dts.push(null); //=== add blank at sunday if month end is not sunday
      }

      if (_.isNull(dts[0])) {
        dts.shift(); //== remove blank from starting for sunday column
      }
    }

    if (parseInt(moment(mdt).format("e")) === 0 && wd !== 0) {
      dts.unshift(null); //== add blank at starting if sunday is the starting day of month
    }

    return dts;
  },

  addZero: (num) => {
    if (num == null) return "00";
    return (num < 10 ? "0" : "") + num;
  },

  getFileIcon: (fname) => {
    const extns = {
      xls: "xls",
      xlsx: "xls",
      pdf: "pdf",
      mp4: "video",
      "3gp": "video",
    };

    const fextn = fname.substring(fname.lastIndexOf(".") + 1);

    return `${process.env.PUBLIC_URL}/images/${_.get(extns, fextn, "information")}.png`;
  },

  getFileName: (fname) => {
    return fname.substring(0, fname.lastIndexOf("."));
  },

  isImgUrl: (fileName) => {
    const imageExtensions = ["jpg", "jpeg", "png", "gif", "bmp"];
    const fileExtension = fileName.split(".").pop().toLowerCase();
    return imageExtensions.includes(fileExtension);
  },

  toLocal: (dt) => {
    let min = parseInt(moment().zone()); // + (moment().isDST() ? 60 : 0);
    //console.log(dt, moment().isDST(), moment().zone(), min);
    return moment(dt).subtract(min, "minutes");
  },

  perpage: 10,

  rotaRooms: () =>
    _.get(process.env, "REACT_APP_ROOM_TYPES", "NoRoom").split(","),

  rotaRoom: (room = 0) => _.get(Utils.rotaRooms(), room, "No Room"),

  viewIcon: (style) => {
    return (
      <span style={style}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
          <path d="M572.5 241.4C518.3 135.6 410.9 64 288 64S57.7 135.6 3.5 241.4a32.4 32.4 0 0 0 0 29.2C57.7 376.4 165.1 448 288 448s230.3-71.6 284.5-177.4a32.4 32.4 0 0 0 0-29.2zM288 400a144 144 0 1 1 144-144 143.9 143.9 0 0 1 -144 144zm0-240a95.3 95.3 0 0 0 -25.3 3.8 47.9 47.9 0 0 1 -66.9 66.9A95.8 95.8 0 1 0 288 160z" />
        </svg>
      </span>
    );
  },
  printIcon: (style) => {
    return (
      <span style={style}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
          <path d="M448 192V77.3c0-8.5-3.4-16.6-9.4-22.6L393.4 9.4c-6-6-14.1-9.4-22.6-9.4H96C78.3 0 64 14.3 64 32v160c-35.4 0-64 28.7-64 64v112c0 8.8 7.2 16 16 16h48v96c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32v-96h48c8.8 0 16-7.2 16-16V256c0-35.4-28.7-64-64-64zm-64 256H128v-96h256v96zm0-224H128V64h192v48c0 8.8 7.2 16 16 16h48v96zm48 72c-13.3 0-24-10.8-24-24 0-13.3 10.8-24 24-24s24 10.7 24 24c0 13.3-10.8 24-24 24z" />
        </svg>
      </span>
    );
  },
  getGapStatusList: () => {
    return [
      [0, "", "Not Defined", "#e0ddddff"],
      [1, "gap_have", "Have This", "#76D773"],
      [2, "gap_working", "Working on it", "#FFBF00"],
      [3, "gap_dont", "Don't Have", "#EC5353"],
      [4, "gap_na", "N/A", "#848484"],
    ];
  },
};

export default Utils;
